import React from 'react';

export function PageFooter() {
    return (
        <footer className="tier page-footer" >
            <div className="grid grid--gutter">
                <div className="grid__col">
                    <p>
                        This tool is largely based on the Contrast-A tool, a Flash
                        based tool created by Annika Hamann (DasPlankton) in January
                        2009.  
                    </p>
                    <p>
                        Because Flash was depreciated by Adobe in January 2021,
                        this new adaptation was created.
                    </p>
                </div>
                <div className="grid__col">
                    <p>
                        The original color deficiency algorith used is an actionscript
                        version of Petr Vanek's VisionDefectColor class which is part
                        of the Scribus project.
                    </p>
                    <p>
                        Petr Vanek's code is based on GIMP's cddisplay_colorblind.c by
                        Michael Natterer, Sven Neumann, Robert Dougherty and Alex Wade
                        from Vischeck.
                    </p>
                </div>
            </div>
        </footer>
    );
}
